import api from 'services/api';

export const FAIXAS_DURACAO = ['0-1h', '1-2h', '2-4h', '4-8h', '8h+', 'sem_medicao'];

const toInt = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? Math.trunc(parsed) : 0;
};

const toFloat = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const normalizeProgressao = (rows) => (Array.isArray(rows) ? rows : [])
  .filter((row) => typeof row?.data === 'string' && row.data !== '')
  .map((row) => ({
    data: row.data,
    abertas: toInt(row.abertas),
    fechadas: toInt(row.fechadas),
  }))
  .sort((a, b) => a.data.localeCompare(b.data));

const normalizeFaixas = (rows) => {
  const map = new Map((Array.isArray(rows) ? rows : [])
    .filter((row) => typeof row?.faixa === 'string')
    .map((row) => [row.faixa, toInt(row.total)]));

  return FAIXAS_DURACAO.map((faixa) => ({ faixa, total: map.get(faixa) ?? 0 }));
};

const normalizeSla = (sla) => ({
  dentro: toInt(sla?.dentro),
  atrasadas: toInt(sla?.atrasadas),
  sem_prazo: toInt(sla?.sem_prazo),
  origem: {
    ixc: toInt(sla?.origem?.ixc),
    meta_assunto: toInt(sla?.origem?.meta_assunto),
    sem_prazo: toInt(sla?.origem?.sem_prazo),
  },
  por_status_ixc: (Array.isArray(sla?.por_status_ixc) ? sla.por_status_ixc : [])
    .filter((row) => typeof row?.status === 'string' && row.status !== '')
    .map((row) => ({ status: row.status, total: toInt(row.total) })),
});

const normalizeCidades = (rows) => (Array.isArray(rows) ? rows : [])
  .filter((row) => typeof row?.cidade === 'string' && row.cidade !== '')
  .map((row) => ({
    cidade: row.cidade,
    os: toInt(row.os),
    media_horas: toFloat(row.media_horas),
  }))
  .sort((a, b) => b.media_horas - a.media_horas || a.cidade.localeCompare(b.cidade, 'pt-BR'));

export const normalizeOsMetrics = (payload) => ({
  progressao: normalizeProgressao(payload?.progressao),
  faixa_duracao: normalizeFaixas(payload?.faixa_duracao),
  sla: normalizeSla(payload?.sla),
  qualidade_execucao: {
    valida: toInt(payload?.qualidade_execucao?.valida),
    nao_positiva: toInt(payload?.qualidade_execucao?.nao_positiva),
    sem_data: toInt(payload?.qualidade_execucao?.sem_data),
  },
  media_execucao_por_cidade: normalizeCidades(payload?.media_execucao_por_cidade),
});

export const SLA_SITUACOES = ['dentro', 'atrasadas', 'sem_prazo'];

const normalizeOrdem = (row) => ({
  id_os: toInt(row?.id_os),
  sla_situacao: typeof row?.sla_situacao === 'string' ? row.sla_situacao : null,
  assunto: row?.assunto ?? null,
  cidade_nome: row?.cidade_nome ?? null,
  funcionario: row?.funcionario ?? null,
  data_abertura: row?.data_abertura ?? null,
  data_hora_execucao: row?.data_hora_execucao ?? null,
  data_final: row?.data_final ?? null,
  data_fechamento: row?.data_fechamento ?? null,
  prazo_efetivo: row?.prazo_efetivo ?? null,
  prazo_origem: row?.prazo_origem ?? null,
  meta_horas: row?.meta_horas === null || row?.meta_horas === undefined ? null : toFloat(row.meta_horas),
  horas_desvio: row?.horas_desvio === null || row?.horas_desvio === undefined ? null : toFloat(row.horas_desvio),
  horas_execucao: row?.horas_execucao === null || row?.horas_execucao === undefined ? null : toFloat(row.horas_execucao),
});

export const normalizeSlaDetalhe = (payload) => ({
  situacao: SLA_SITUACOES.includes(payload?.situacao) ? payload.situacao : null,
  total: toInt(payload?.total),
  exibidas: toInt(payload?.exibidas),
  truncado: payload?.truncado === true,
  totais_por_situacao: {
    dentro: toInt(payload?.totais_por_situacao?.dentro),
    atrasadas: toInt(payload?.totais_por_situacao?.atrasadas),
    sem_prazo: toInt(payload?.totais_por_situacao?.sem_prazo),
  },
  ordens: (Array.isArray(payload?.ordens) ? payload.ordens : [])
    .filter((row) => row && typeof row === 'object')
    .map(normalizeOrdem),
});

class OsMetricsService {
  async buscarMetricas({ data_inicio, data_fim }, signal = null) {
    const config = signal ? { signal } : {};
    const response = await api.post('/infraestrutura/os/metrics', { data_inicio, data_fim }, config);

    return normalizeOsMetrics(response.data?.data ?? response.data);
  }

  async buscarDetalheSla({ data_inicio, data_fim, situacao }, signal = null) {
    const config = signal ? { signal } : {};
    const response = await api.post(
      '/infraestrutura/os/metrics/sla',
      { data_inicio, data_fim, situacao },
      config,
    );

    return normalizeSlaDetalhe(response.data?.data ?? response.data);
  }
}

const osMetricsService = new OsMetricsService();

export default osMetricsService;
